export default __webpack_public_path__ + "img/dIelpmTD.bb643afa.svg";